import { DefaultTheme } from 'styled-components';
import 'styled-components/macro';
import resolveConfig from 'tailwindcss/resolveConfig';

import config from '../tailwind.config';

const twConfig = resolveConfig(config);

const deprecatedTheme = {
  red: {
    base: '#EB3C1A',
  },
  blue: {
    base: '#252F42',
    dark: '#1C2639',
    darker: '#171F2E',
    darkest: '#1A2231',
    light: '#4E586D',
    lighter: '#959FB1',
  },
  purple: {
    base: '#8706BA',
  },
  green: {
    base: '#00A878',
  },
  yellow: {
    base: '#FFBF00',
  },
  gray: {
    dark: '#CDD2DA',
    base: '#E2E7EB',
    light: '#F0F3F6',
    lighter: '#F5F7FA',
  },
  black: {
    base: '#000000',
  },
  white: {
    base: '#FFFFFF',
  },
};

declare module 'styled-components' {
  export interface DefaultTheme {
    /**
     * These are the colours of the deprecated theme
     *
     * @deprecated Don't use the deprecated theme, use tailwind
     */
    colors: typeof deprecatedTheme;
  }
}

const theme = {
  ...twConfig.theme,

  // Deprecated theme
  colors: deprecatedTheme,
} as DefaultTheme;

export default theme;
